import { render } from "./DialogConfirmation.vue?vue&type=template&id=c5b74c54&scoped=true"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js"

import "./DialogConfirmation.vue?vue&type=style&index=0&id=c5b74c54&scoped=true&lang=css"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b74c54"]])

export default __exports__